







































































import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'
import CookieConsentModal from '@/components/cookie-consent/CookieConsentModal.vue'
import { TcCheckbox } from '@telia/shared-ui-components'
import {
  onMounted,
  defineComponent,
  computed,
  Ref,
  ref
} from '@vue/composition-api'
import { TcButton } from '@telia/shared-ui-components'
import {
  getLevelSelected,
  updateLevelSelected,
  closeMainModal
} from '@/store/modules/cookie-consent.store'
import { ClickEvent } from '@/types/contact-form-page.types'

export default defineComponent({
  components: {
    RichTextContainer,
    TcCheckbox,
    CookieConsentModal,
    TcButton
  },
  props: {
    content: Object
  },
  setup (props, { root }) {
    const store = root.$store
    const consentLevelsArray: Ref<number[]> = ref([])

    const levelSelected = computed(() => getLevelSelected(store))

    const getSequenceUpToMaxValue = (values: number[]): number[] => {
      const maxValue = Math.max(...values)

      const result = []
      for (let i = 1; i <= maxValue; i++) {
        result.push(i)
      }

      return result
    }

    const handleConsentSelect = (val: ClickEvent) => {
      const clickedValue = parseInt(val.target.value)

      if (consentLevelsArray.value.includes(clickedValue)) {
        consentLevelsArray.value = consentLevelsArray.value.filter((i) => i !== clickedValue)
      } else {
        consentLevelsArray.value.push(clickedValue)
      }

      consentLevelsArray.value = getSequenceUpToMaxValue(consentLevelsArray.value)
    }

    onMounted(() => {
      consentLevelsArray.value = getSequenceUpToMaxValue([levelSelected.value])
    })

    const updateConsentLevel = () => {
      updateLevelSelected(store, consentLevelsArray.value.length)
      closeMainModal(store)
    }

    return {
      handleConsentSelect,
      consentLevelsArray,
      updateConsentLevel
    }
  }
})
